import { useSelector } from 'react-redux';
import { getHasCustomerAgentWriteAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import { requestSucceeded } from 'redux-request-state/util/requestStateCheckers';
import { getPostPublishCustomerAgentNextReminderDate } from '../redux/selectors/cmsSettingsSelectors';
import { useMemo } from 'react';
import I18n from 'I18n';
import { getFetchCmsSettingsRequest } from '../redux/selectors/requestStatesSelectors';
import { useHasConfiguredCustomerAgent } from 'customer-agent-discovery-components-lib/data/customer-agents/useHasConfiguredCustomerAgent';
export const useShouldDisplayPostPublishCustomerAgentModal = () => {
  const hasCustomerAgentWriteAccess = useSelector(getHasCustomerAgentWriteAccess);
  const fetchCmsSettingsRequest = useSelector(getFetchCmsSettingsRequest);
  const isFetchCmsSettingsRequestSucceeded = requestSucceeded(fetchCmsSettingsRequest);
  const postPublishCustomerAgentNextReminderDate = useSelector(getPostPublishCustomerAgentNextReminderDate);
  const shouldDisplayModalBasedOnNextReminderDate = useMemo(() => {
    if (!postPublishCustomerAgentNextReminderDate) {
      return true;
    } else if (postPublishCustomerAgentNextReminderDate !== -1) {
      const currentDate = I18n.moment().valueOf();
      return currentDate > postPublishCustomerAgentNextReminderDate;
    }
    return false;
  }, [postPublishCustomerAgentNextReminderDate]);
  const {
    hasConfiguredAgent
  } = useHasConfiguredCustomerAgent();
  const isSeleniumRunning = window.SELENIUM_IS_RUNNING;
  return hasCustomerAgentWriteAccess && isFetchCmsSettingsRequestSucceeded && shouldDisplayModalBasedOnNextReminderDate && !hasConfiguredAgent && !isSeleniumRunning;
};